<template>
  <v-container fluid class="mt-5 d-flex justify-center">
    <v-card v-show="folioData.Estatus !== 2" class="pa-6" outlined max-width="600">
      <v-card-title class="headline font-weight-bold justify-center">
        Información de Folio
      </v-card-title>

      <v-card-text class="d-flex flex-column align-center text-center">

        <!-- Loading -->
        <div v-if="loading" class="d-flex flex-column align-center mb-4">
          <v-progress-circular indeterminate color="primary" class="mb-2"></v-progress-circular>
          <span class="subtitle-1">Buscando folio...</span>
        </div>

        <!-- Error -->
        <v-alert v-else-if="error" type="error" dense outlined class="mb-4">
          {{ error }}
        </v-alert>

        <!-- Datos del folio -->
        <div v-else-if="folioData" class="d-flex flex-column align-center mb-4">
          <!-- Alerta de folio encontrado -->
          <v-alert v-if="folioData.FecCierre || folioData.FecAcude" type="info" dense outlined class="mb-4" border="left" prominent>
            <div>
             Este pase médico <b>ya fue utilizado</b> en una consulta previa. <br/>
            La presente consulta deberá ser cubierta en su totalidad por el paciente
            </div>
          </v-alert>

          <v-alert v-else type="success" dense outlined class="mb-4" border="left" prominent>
            <div>
              <strong>Folio encontrado:</strong> {{ folioData.Folio }}
            </div>
            <div>
              Este pase médico es <b>válido</b> para cubrir la consulta médica.
            </div>
          </v-alert>

          <!-- Datos del folio -->
          <div class="mb-2">
            <v-icon left small color="primary">mdi-account</v-icon>
            <strong>Médico especialista:</strong> {{ folioData.Medico }}
          </div>

          <div class="mb-2">
            <v-icon left small color="primary">mdi-stethoscope</v-icon>
            <strong>Especialidad:</strong> {{ folioData.Especialidad }}
          </div>

          <div class="mb-2">
            <v-icon left small color="primary">mdi-account-circle</v-icon>
            <strong>Paciente:</strong> {{ folioData.Paciente }}
          </div>

          <div class="mb-2">
            <v-icon left small color="primary">mdi-account-group</v-icon>
            <strong>Parentesco:</strong> {{ folioData.Parentesco }}
          </div>

          <div class="mb-2">
            <v-icon left small color="primary">mdi-calendar</v-icon>
            <strong>Fecha de asistencia:</strong>
            {{ formatFecha(folioData.FecAcude) || 'SIN FECHA' }}
          </div>

          <!-- Alerta de error si aplica -->
          <v-alert v-if="errorresponse" type="error" dense outlined border="left" prominent class="mb-4">
            {{ errorresponse }}
          </v-alert>

          <!-- Botón acción -->
          <v-row justify="center" class="mt-4">
            <v-btn color="primary" class="mx-2" :disabled="folioData.FecCierre || folioData.FecAcude"
              @click="marcarConsulta" outlined block>
              <v-icon left>mdi-check</v-icon>
              Marcar asistencia del paciente
            </v-btn>
          </v-row>
        </div>


        <!-- Folio no encontrado -->
        <v-alert v-else type="error" dense outlined border="left" prominent>
          <span>
            <strong>Folio no encontrado.</strong>
            Este pase médico <b>no es válido</b>.
            La consulta deberá ser cubierta en su totalidad por el paciente.
          </span>
        </v-alert>

      </v-card-text>
    </v-card>
<v-card
  v-show="folioData.Estatus === 2"
  class="pa-6 mx-auto"
  outlined
  max-width="600"
>
  <v-card-title class="headline font-weight-bold justify-center">
    Estado del Folio
  </v-card-title>

  <v-divider class="mb-4"></v-divider>

  <v-card-text class="d-flex flex-column align-center text-center">

    <v-icon
      color="error"
      size="64"
      class="mb-4"
    >
      mdi-alert-circle-outline
    </v-icon>

    <v-alert
      type="error"
      outlined
      border="left"
      prominent
      class="text-left"
    >
      <div class="mb-2">
        <strong>Folio cancelado</strong>
      </div>

      <div class="mb-2">
        Este pase médico <b>no es válido</b>.
      </div>

      <div>
        La consulta deberá ser cubierta en su totalidad por el paciente.
      </div>
    </v-alert>
  </v-card-text>
</v-card>
  </v-container>
</template>

<script>
import formatFecha from '@/mixins/formatFecha'

export default {
  name: "ConsultaFolio",
  mixins: [formatFecha],
  props: {
    cita: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      error: null,
      folioData: null,
      errorresponse: null
    }
  },
  mounted() {
    if (this.cita) {
      this.getCita()
    }
  },
  methods: {
    getCita() {
      this.loading = true
      this.error = null
      this.folioData = null
      this.$http.post(`consulta/obtiene`, { IdCita: this.cita })
        .then(response => {
          if (response.status === 200 && response.data) {
            this.folioData = response.data
          }
        })
        .catch(err => {
          this.error = "Error al consultar el folio."
          console.error(err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    marcarConsulta() {
      this.$swal.fire({
        title: 'Ingresar RFC del médico',
        input: 'text',
        inputPlaceholder: 'Ej. ABCD001122XXX',
        showCancelButton: true,
        confirmButtonText: 'Guardar',
        inputAttributes: {
          maxlength: 13,
          style: 'text-transform:uppercase' // fuerza mayúsculas
        },
        preConfirm: (value) => {
          const rfcRegex = /^([A-ZÑ&]{3,4})(\d{6})([A-Z\d]{3})$/i
          if (!rfcRegex.test(value)) {
            this.$swal.showValidationMessage('⚠️ RFC inválido, verifícalo')
          }
          return value.toUpperCase()
        }
      }).then((result) => {
        if (result.isConfirmed) {
          this.$http.post(`consulta/closeqr`,
            {
              IdCita: this.folioData.Ide,
              RFCMedico: result.value
            })
            .then(response => {
              this.folioData.FecAcude = response.data.Mensaje
              this.$swal.fire({
                icon: 'success',
                title: 'Gracias por registrar esta consulta, cuando tenga lista su factura no olvide enviarla por correo.',
                text: response.data.Mensaje,
                confirmButtonText: 'Aceptar'
              });
            })
            .catch(err => {
              if (err.response && err.response.data) {
                // Captura mensaje de tu API
                this.errorresponse = err.response.data.Mensaje || "Ocurrió un error al procesar la solicitud.";
              } else {
                this.errorresponse = "Error de red o servidor no disponible.";
              }
            })
            .finally(() => {
              this.loading = false
              
            })
        }
      })
    }
  }
}
</script>
